import React from 'react';
// import { getThemeProps } from '@material-ui/styles';
import {IconButton, Avatar, Tooltip} from '@mui/material';
// import { blue } from '@mui/material/colors';
import { styled, ThemeProvider } from "@mui/material/styles";
import theme from '../Styles/MuiTheme';

const StyledAvatar = styled(Avatar)(({theme, selected}) => ({
  width: selected ? theme.spacing(8) : theme.spacing(7),
  height: selected ? theme.spacing(8) : theme.spacing(7),
  border: '2px solid #ccc',
  borderRadius: '15%', // change to %50 to be rounded
  variant:"rounded",
}));



export default function MaterialSwatch(props) {
  // const classes = useStyles();
  const type = "select";
  const {name, source, pId, setValue, value, idx} = props;
  // console.log(name, source)
  // console.log()

  const onChange = (event) => {
    // console.log(`value: ${value}`);
    // console.log(`idx: ${idx}`);
    // console.log(event.target.value, pId, setValue)
    setValue(idx, pId, type);
  }

  return (
    // <div className={classes.root}>
    <div>
      <ThemeProvider theme={theme}>
        <Tooltip title={name} arrow>
          <IconButton size="medium" onClick={onChange}>
          <StyledAvatar alt={name} src={source} />
          </IconButton>
        </Tooltip>
      </ThemeProvider>
    </div>
  );
}